import {Flex, Popover} from "antd";
import {useTranslation} from "react-i18next";

const AddressMacTagList = ({addressMac}: { addressMac?: string | null }) => {
    const {t} = useTranslation();
    const addressMacList = String(addressMac).split(";");

    return (
        <div>
            <Popover
                content={<AddressMacDetailContent addressMacList={addressMacList}/>}
                title={<div className={'text-color-1 text-size-3 font-bold mt-3'}>{t('field.addressMac') + ":"}</div>}
                overlayClassName={addressMacList.length > 4 ? '' : 'hidden'}
                placement="top"
                trigger="hover"
            >
                <div className={addressMacList.length > 4 ? "hover:cursor-pointer" : ""}>
                    {
                        addressMacList.slice(0, 4).map((address, index) => {
                            if (index % 2 === 0) {
                                return (
                                    <Flex key={address + index} className={'w-fit'}>
                                    <span className={'whitespace-nowrap'}>
                                         {addressMacList[index]}{index === addressMacList.length - 1 ? null : <>;&nbsp;</>}
                                    </span>
                                        {
                                            addressMacList[index + 1] &&
                                            <span className={'whitespace-nowrap'}>
                                        {addressMacList[index + 1]}{index === addressMacList.length - 2 ? null : <>;&nbsp;</>}
                                    </span>
                                        }
                                    </Flex>
                                )
                            }
                        })
                    }
                    {
                        addressMacList.length > 4 &&
                        <div className={'w-fit text-[#4A58EC] text-lg align-middle'}>...</div>
                    }
                </div>
            </Popover>
        </div>
    )
}

const AddressMacDetailContent = ({addressMacList}: { addressMacList: string[] }) => {
    return (<div className={'mb-3'}>
        {
            addressMacList.map((address, index) => {
                if (index % 3 === 0) {
                    return (
                        <Flex key={address + index} className={'w-fit'}>
                            <span className={'whitespace-nowrap pr-3'}>
                                 {addressMacList[index]}{index === addressMacList.length - 1 ? null : <>;&nbsp;</>}
                            </span>
                            {
                                addressMacList[index + 1] &&
                                <span className={'whitespace-nowrap pr-3'}>
                                    {addressMacList[index + 1]}{index === addressMacList.length - 2 ? null : <>;&nbsp;</>}
                                </span>
                            }
                            {
                                addressMacList[index + 2] &&
                                <span className={'whitespace-nowrap'}>
                                    {addressMacList[index + 2]}{index === addressMacList.length - 3 ? null : <>;&nbsp;</>}
                                </span>
                            }
                        </Flex>
                    )
                }
            })
        }
    </div>)
}

export default AddressMacTagList;